import React from 'react';
import { BaseProfile } from './PersonalBase/index';
import { PersonalInformation } from './PersonalInformation';
import { Retry, Footer } from '@src/components/common';
import { useOktaDetails } from './hooks';
import Cookies from 'js-cookie';
import { getUserProfile } from '@store/common/selectors';
import { useSelector } from 'react-redux';
import { ProfileContainer } from './styled';

function getUrlParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    userName: params.get('username') || '',
    standAlone: params.get('standalone') === 'true',
  };
}

export const MyProfile = () => {
  const { userName, standAlone } = getUrlParams();
  const {
    data: oktaData,
    isLoading: isLoading,
    isError: isError,
    refetch: refetchOkta,
  } = useOktaDetails(userName, standAlone);

  const isFederated = Cookies.get('_is_federated') === '1' || false;
  const userProfile = useSelector(getUserProfile);

  return (
    <Retry
      isLoading={isLoading}
      fetchData={async () => {
        await refetchOkta();
      }}
      showError={isError}
    >
      {!isLoading ? (
        <ProfileContainer>
          <BaseProfile
            userInfo={{
              userName: userProfile?.username,
              customerName: userProfile?.customer_name,
              role: userProfile?.role,
            }}
            profileName="Personal Information"
            standAlone={standAlone}
          />
          <PersonalInformation
            oktaData={oktaData}
            isFederated={isFederated}
            standAlone={standAlone}
          />
          <Footer />
        </ProfileContainer>
      ) : null}
    </Retry>
  );
};
